import { SearchContext } from "@/shared/search/search.types";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases";
import { useAbilityRoute } from "@/shared/environment/ability-route";

export const useActivityRoute = () => {
    const { getPathToChildrenWithoutParents, getRouteElementsBySearchContext } = useAbilityRoute();

    const calculatePathForActivities = (searchContext?: SearchContext) => {
        const routeElements = searchContext ? getRouteElementsBySearchContext(searchContext) : [];

        routeElements.push({
            alias: CommonRouteAliases.activities,
            namedParams: {},
        });

        return getPathToChildrenWithoutParents(routeElements);
    };

    const calculatePathForActivitiesSubalias = (
        routeAlias: CommonRouteAliases.activityOverview | CommonRouteAliases.activityDetail,
        activityId: string,
        searchContext?: SearchContext
    ) => {
        const routeElements = searchContext ? getRouteElementsBySearchContext(searchContext) : [];

        routeElements.push({
            alias: CommonRouteAliases.activities,
            namedParams: {},
        });

        if (activityId) {
            routeElements.push({
                alias: routeAlias,
                namedParams: { activityId },
            });
        }

        return getPathToChildrenWithoutParents(routeElements);
    };

    return {
        calculatePathForActivities,
        calculatePathForActivitiesSubalias,
    };
};
